import { useRef } from "react";
import { useDispatch } from "react-redux";
import websocketService from "../../services/websocketService";
import {
  appendChatMessage,
  appendStreamMessage,
  setLoading,
} from "../../actionCreator/genAIActionCreator";
import { allowedStages } from "../../reducers/genAIReducer";

export const useEmailWebSocket = (channel) => {
  const subscriptionRef = useRef(null);
  const dispatch = useDispatch();

  const subscribeToSession = async (sessionId, onMessage) => {
    if (!sessionId) return;

    await websocketService.connectWS();
    const topic = `/topic/${channel}/session-${sessionId}`;

    subscriptionRef.current = websocketService.subscribe(topic, (chunk) => {
      if (channel === "email-channel-1") dispatch(appendStreamMessage(chunk));
      if (channel === "chat-channel-1") {
        dispatch(setLoading(true));
        dispatch(appendChatMessage(JSON.parse(chunk)));
        if (allowedStages.includes(JSON.parse(chunk)?.stage))
          dispatch(setLoading(false));
      }

      onMessage?.(chunk);
    });
  };

  const unsubscribeFromSession = () => {
    if (subscriptionRef.current) {
      subscriptionRef.current.unsubscribe();
      subscriptionRef.current = null;
    }
    websocketService.disconnect();
  };

  const sendInputToSession = (payload, token) => {
    websocketService.send("/app/chat/input", payload, {
      Authorization: `Bearer ${token}`,
    });
  };

  return {
    subscribeToSession,
    unsubscribeFromSession,
    sendInputToSession,
  };
};
